import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export async function recoveryUserPassword(userId: number, password: string) {
  return usersApi.post(apiRoutes.recoveryUserPass, {
    password,
    id: userId,
  })
}
